import api from '../../api'

import {
    SET_APPRAISAL_NOTES
} from '../../constants'

const default_state = {
    notes: {
        note_001: {
            name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
            name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
            name_en: ''
        },
        note_002: {
            name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
            name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
            name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
        },
        note_003: {
            name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
            name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
        },
        note_004: {
            name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
            name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
            name_en: 'Both BARNA-Charges, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
        },
        note_005: {
            name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
            name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
            name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
        },
        note_006: {
            name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
            name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
            name_en: 'The valuation has been made considering the property is free of charges and liens'
        }
    }
}
const state = default_state

const actions = {
    FETCH_APPRAISAL_NOTES: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_appraisal_notes) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_APPRAISAL_NOTES, res)
            })
    },
    SET_APPRAISAL_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NOTES, data)
    },
    UPDATE_APPRAISAL_NOTES: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.object,
                path: 'appraisal_notes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then((res) => {
                resolve()

            })

        })
    },
}

const mutations = {
    [SET_APPRAISAL_NOTES] (state, data) {
        state.notes = check_undefined(data)
    }
}

const getters = {
    appraisal_notes: state => {
        return state.notes
    }
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/appraisal/appraisal_notes.js